<template>

<com-logic>

    <com-input :type="type" :rule="rule" v-model="model.value" />

    <div class="logic-text"> to </div>

    <com-input :type="type" :rule="rule" v-model="model.to" />

</com-logic>

</template>

<script>

import mixLogic from './logic'

export default {

    mixins: [mixLogic],

    data: function() {

        return {
            noOperand: true,
            model: {
                operand: '=',
                value: '',
                to: ''
            }
        }
        
    }

}

</script>

<style scoped>

</style>